import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'

export default {
    name: 'DictionaryList',
    props: {
        dictionary: {
            type: Object,
            required: true
        },
        showFilter: {
            type: String,
            required: false
        }
    },
    setup(props) {
        const store = useStore()
        const filterLetter = ref('')
        const dictionaryData = computed(
            () => store.getters['search/dictionaryData']
        )
        const displayList = computed(() =>
            store.getters['search/dictionaryFilterBySearch'].filter((group) =>
                filterLetter.value
                    ? group.letter.toUpperCase() === filterLetter.value
                    : true
            )
        )
        const startLettersComplete = [
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
            'N',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'T',
            'U',
            'V',
            'W',
            'X',
            'Y',
            'Z',
            'Æ',
            'Ø',
            'Å'
        ]
        const startLettersDisplay = computed(() => {
            return startLettersComplete.map((letter) => {
                return {
                    letter: letter,
                    disabled: !dictionaryData.value.find(
                        (group) => group.letter === letter.toUpperCase()
                    )?.words.length,
                    selected:
                        filterLetter.value === letter.toUpperCase()
                            ? 'kb-dictionary-list--selected'
                            : ''
                }
            })
        })

        const getLabel = (labelKey) =>
            store.getters['labels/getLabel']({
                labelCollection: 'dictionaryList',
                labelKey: labelKey
            })

        const filterOnLetter = function (letter) {
            filterLetter.value = filterLetter.value === letter ? '' : letter
        }

        const showFilter = computed(() => props.showFilter)

        onMounted(() => {
            store.commit('search/set_dictionary_data', props.dictionary)
        })

        return {
            displayList,
            filterOnLetter,
            filterLetter,
            startLettersDisplay,
            showFilter,
            getLabel
        }
    }
}
